import { motion } from "framer-motion";
import { SCHEDULE } from "@/lib/wedding";

/**
 * Itinerary
 * -----------------------------------------------------------
 * Ceremony cards driven by SCHEDULE in wedding.js (the printed card's
 * programme): a heading per day, then one card per item. Part-filled rows
 * are centred so each day reads as its own block.
 */
const FADE_LINE = {
  background: "linear-gradient(90deg, rgba(201,169,97,0) 0%, rgba(201,169,97,0.7) 50%, rgba(201,169,97,0) 100%)",
};

export default function Itinerary() {
  return (
    <section id="itinerary" className="relative edge py-24 bg-ivory text-center">
      <div className="overline text-rani mb-5">Shubh Muhurat</div>
      <h2 className="font-display text-4xl sm:text-6xl text-rani">Ceremonies</h2>
      <div
        className="mx-auto mt-6 mb-14 h-px w-40"
        style={FADE_LINE}
      />

      <div className="max-w-6xl mx-auto space-y-14">
        {SCHEDULE.map((d) => (
          <div key={d.date}>
            <div className="mb-6 flex items-center justify-center gap-4">
              <span className="h-px w-8 sm:w-24" style={FADE_LINE} />
              <h3 className="font-display text-xl sm:text-3xl text-rani whitespace-nowrap">{d.day}</h3>
              <span className="h-px w-8 sm:w-24" style={FADE_LINE} />
            </div>
            <div className="flex flex-wrap justify-center gap-6">
              {d.items.map((e, i) => (
                <motion.article
                  key={e.time + e.name}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-60px" }}
                  transition={{ duration: 0.8, delay: (i % 3) * 0.12, ease: [0.22, 1, 0.36, 1] }}
                  className="w-full md:w-[calc(50%-0.75rem)] lg:w-[calc(33.333%-1rem)] text-left border border-gold bg-bone rounded-2xl overflow-hidden flex flex-col"
                >
                  {/* Thin gold band in place of a photo */}
                  <div className="h-1.5" style={{ background: "linear-gradient(90deg, #C9A961 0%, #E8CC7E 50%, #C9A961 100%)" }} />
                  <div className="p-6 flex flex-col flex-1">
                    <h3 className="font-display text-2xl text-rani">{e.name}</h3>
                    <div className="mt-2 text-[11px] uppercase tracking-chip text-gold-deep">
                      {d.date} · {e.time}
                    </div>
                    {e.detail && <div className="mt-1 font-display italic text-ink/70">{e.detail}</div>}
                    {e.blurb && <p className="mt-3 font-body text-ink/80 leading-relaxed text-sm">{e.blurb}</p>}
                  </div>
                </motion.article>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
